import { Component, OnInit } from '@angular/core';
import { SitesettingsService } from '../../services/sitesettings.service';
import { environment } from './../../../environments/environment';
import { TranslateService } from '@ngx-translate/core';

const API_URL = environment.API_URL;
const ASSET_URL = environment.DO_ENDPOINT;
const HEADER_LOGO_CACHE_KEY = "front_header_logo_url";

@Component({
  selector: 'app-frontheader',
  templateUrl: './frontheader.component.html',
  styleUrls: ['./frontheader.component.scss']
})
export class FrontheaderComponent implements OnInit {
  sitelogo: any;
  textDir: any;
    url: any;
    asset_url: any;
  constructor(private service: SitesettingsService, private translate: TranslateService) { }

  ngOnInit() {
   this.sitelogo = localStorage.getItem(HEADER_LOGO_CACHE_KEY) || "";
   this.url = API_URL;
   this.asset_url = ASSET_URL;
    this.getsitedata();
  }

  getsitedata() {
    this.service.getsitesettings().subscribe(
      (res: any) => {
        const logoName =
          res && res.result && res.result[0] && res.result[0].logo
            ? res.result[0].logo
            : "";
        const logoUrl = logoName ? ASSET_URL + "/logos/" + logoName : "";
        this.sitelogo = logoUrl;
        if (logoUrl) {
          localStorage.setItem(HEADER_LOGO_CACHE_KEY, logoUrl);
        }
      },
      () => {
        // Fallback to public endpoint shape if legacy endpoint fails.
        this.service.getsitedatasettings().subscribe((res: any) => {
          const logoName = res && res.result ? res.result.logo : "";
          const logoUrl = logoName ? ASSET_URL + "/logos/" + logoName : "";
          this.sitelogo = logoUrl;
          if (logoUrl) {
            localStorage.setItem(HEADER_LOGO_CACHE_KEY, logoUrl);
          }
        });
      }
    );
  }
    switchLanguage(language: string) {
        this.translate.use(language);
        
     if(language == 'ar')
      {
        this.textDir = 'rtl';
        document.body.setAttribute("dir", "rtl");
      } 
      else
      {
        this.textDir = 'ltr';
          document.body.setAttribute("dir", "ltr");
      }

       
    }

}
